export const enum ConversionItemStatus {
  Success = 'success',
  Failure = 'failure',
  Pending = 'pending',
}

export type ConversionItem = {
  label: ConversionItemStatus;
  value: number;
  count: number;
};

export type TotalOrdersGroups = {
  successGroup: number;
  failureGroup: number;
  pendingGroup: number;
};

export type TotalOrders = {
  created: number;
  prepared: number;
  pending: number;
  expired: number;
  failure: number;
  cancelled: number;
  success: number;
  refund: number;
  chargeback: number;
  orderCount: number;
  groups: TotalOrdersGroups;
};

export type GatewayConversionListItem = {
  id: number;
  name: string;
  messages: string[];
  conversionItems: ConversionItem[];
  gatewayConversionSettingId: number | null;
};

export type OrderConversionProviderChartDatasetItem = {
  count: number;
  percentage: number;
  status: string;
};

export type OrderConversionProviderChartDataset = {
  failure: OrderConversionProviderChartDatasetItem;
  pending: OrderConversionProviderChartDatasetItem;
  success: OrderConversionProviderChartDatasetItem;
  total: OrderConversionProviderChartDatasetItem;
  providerId: number;
  providerName: string;
};

type OrderConversionPeroiodChartDataset = {
  label: string;
  data: number[];
  backgroundColor: string;
  stack: string;
};

export type OrderConversionProviderChart = {
  total: OrderConversionProviderChartDataset;
  providers: OrderConversionProviderChartDataset[];
};

export type OrderConversionPeriodChart = {
  labels: string[];
  datasets: OrderConversionPeroiodChartDataset[];
};

export type OrderConversionChartData = {
  conversionByProvider: OrderConversionProviderChart;
  conversionByPeriod: OrderConversionPeriodChart;
};

export enum OrderConversionChartStatuses {
  Success = 'success',
  Failure = 'failure',
  Pending = 'pending',
}
